// USER DATA
if( typeof user_data === 'undefined' ) {
	var user_data = false;
}

// BROWSER STORAGE SET
var browser_storage_set = function( key, variable ) {
	if( typeof variable !== 'undefined' ) {
		if( user_data && user_data.cookies == 'yes' ) {
			localStorage.setItem( key, variable );
		} else {
			sessionStorage.setItem( key, variable );
		}
	}
}
// BROWSER STORAGE GET
var browser_storage_get = function( key ) {
	if( user_data && user_data.cookies == 'yes' && localStorage.getItem( key ) ) {
		return localStorage.getItem( key );
	} else if( user_data && user_data.cookies == 'yes' && sessionStorage.getItem( key ) ) {
		browser_storage_set( key, sessionStorage.getItem( key ) );
		return sessionStorage.getItem( key );
	} else {
		return sessionStorage.getItem( key );
	}
}

var update_session_localstorage = function(){
	$.each(sessionStorage, function(key, value) {
		if( typeof value !== 'function' && ! localStorage.getItem(key) && key !== 'length' ) {
			localStorage.setItem(key, value);
		}
	})
}